@if (showSizeControl) {
  <div class="dag-head">
    <div class="dag-size" role="group" aria-label="Artwork size">
      <button type="button" [class.active]="size === 'sm'" (click)="setSize('sm')" title="Small"><i class="fa fa-th"></i></button>
      <button type="button" [class.active]="size === 'md'" (click)="setSize('md')" title="Medium"><i class="fa fa-th-large"></i></button>
      <button type="button" [class.active]="size === 'lg'" (click)="setSize('lg')" title="Large"><i class="fa fa-square-o"></i></button>
    </div>
  </div>
}

<div class="dag-grid" [style.--dag-min.px]="minPx">
  <ng-content></ng-content>
</div>
